import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmDialogInput {
  title: string
  message: string
  confirmButtonText: string | undefined
  cancelButtonText: string | undefined
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {

  title: string
  message: string
  confirmButtonText = 'Ok'
  cancelButtonText = 'Cancel'

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogInput,
    private dialogRef: MatDialogRef<ConfirmDialogComponent, boolean>) {
    this.title = data.title
    this.message = data.message

    if (data.confirmButtonText) this.confirmButtonText = data.confirmButtonText
    if (data.cancelButtonText) this.cancelButtonText = data.cancelButtonText
  }

  ngOnInit(): void {
  }

  onConfirmClick() {
    this.dialogRef.close(true)
  }

  onCancelClick() {
    this.dialogRef.close(false)
  }

  static createConfigurations(input: ConfirmDialogInput): MatDialogConfig {
    return {
      data: input,
      autoFocus: false,
      disableClose: true
    }
  }

}
